import es, { humanized as humanizedEs, remaining as remainingEs } from './es';
import pt, { humanized as humanizedPt, remaining as remainingPt } from './pt';

export type TranslationType = typeof humanizedEs;

export const humanized = {
  es: humanizedEs,
  pt: humanizedPt,
};

export const remaining = {
  es: remainingEs,
  pt: remainingPt,
};

export default { es, pt };
